document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slider-grid').forEach(function (sliderGrid) {
    sliderGrid.querySelectorAll('.carousel-btn, [data-direction]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          sliderGrid.querySelectorAll('.scroll-trigger--offscreen').forEach(function (el) {
            el.classList.remove('scroll-trigger--offscreen');
            el.classList.add('scroll-trigger--onscreen');
          });
        }, 100);
      });
    });
  });
});
